export default __webpack_public_path__ + "static/media/client-3.4027a5a9.jpg";